jQuery(function($) {
  function toggleLearnMoreVisibility(accordionContent) {
    const accordionContentHeight = accordionContent[0].scrollHeight;
    const learnMoreButton = accordionContent.siblings('.learn-more');

    if(accordionContentHeight >= 240) {
      learnMoreButton.css('display', 'inline-block');
    }
  }

  $('.learn-more').click(function() {
    const accordionContent = $(this).siblings('.learn-more-container');
    const accordionContentHeight = accordionContent[0].scrollHeight;

    accordionContent.toggleClass('active');
    $(this).toggleClass('active');

    if(accordionContent.hasClass('active')) {
      accordionContent.css('max-height', `${accordionContentHeight}px`);
      $(this).html('Learn Less<span class="accordion-item--toggle"></span>');

    } else {
      accordionContent.css('max-height', `240px`);
      $(this).html('Learn More<span class="accordion-item--toggle"></span>');
    }
  });

  const accordionContent2 = $('.learn-more').siblings('.learn-more-container');
  if(accordionContent2.length > 0) {
    toggleLearnMoreVisibility(accordionContent2);
  }
});